import { calculateSimpleExpressionSync } from '@lmt/expressions';
import { MeasuredValue } from '@lmt/unicorn-shared/app/features/measurements/types';

export const formulaPrefix = 'EVAL:';
const keyRegexp = /0.FG.\d+.\d+/g;

/* Examples of formulas:
 * EVAL:0.FG.0.3/4
 * EVAL:(0.FG.0.3/4+0.FG.0.2/100000)*2
 */

export function calculateFormula(
  defaultFormula: string,
  measuredValues: Pick<MeasuredValue, 'value' | 'key'>[],
): string | null {
  let formula = defaultFormula.replace(formulaPrefix, '');
  const variables: Record<string, number> = {};
  const keys = formula.match(keyRegexp);
  if (keys) {
    for (const sorceName of keys) {
      if (
        !measuredValues.find((m) => m.key === sorceName) ||
        measuredValues.find((m) => m.key === sorceName && !m.value)
      ) {
        return null;
      }
    }
  }
  // we sort measurement keys from longest to shortest before replacing them,
  // because it could be the case when a key includes another key
  measuredValues
    .filter((measuredValue) => formula.includes(measuredValue.key))
    .sort((a, b) => b.key.length - a.key.length)
    .forEach((measuredValue, index) => {
      const value = parseFloat(measuredValue.value.replace(',', '.'));
      if (Number.isNaN(value)) {
        throw new Error(`${measuredValue.key} has wrong value`);
      }
      // we use `index` instead of `measuredValue.key`, because otherwise
      // `EVAL:0.FG.0.31+0.FG.0.3` turns into EVAL:data['data['0.FG.0.3']1']+data['0.FG.0.3']
      const variableName = `data[${index}]`;
      formula = formula.replaceAll(measuredValue.key, variableName);
      variables[index] = value;
    });
  const result = calculateSimpleExpressionSync(formula, variables);
  if (result === null) {
    throw new Error("Can't parse formula");
  }
  return result;
}
